import React from "react";
import moment from 'moment';
import withSnackbar from "../../util/withSnackbar";
import { withRouter } from "react-router-dom";
import { injectIntl } from "react-intl";
import { LinearProgress } from '@mui/material';
import queryString from 'query-string';
import zoomButtonIcon from "../../img/img_Fullscreen_on.svg"
import { SNACKBAR_OPTIONS, DATE_FORMAT, TIMEOUT } from '../../constants/CommonConstants';
import { TroubleDataGrid } from "../../Common/TroubleDataGrid";
import { checkRevision } from '../../Common/revisionCheck';
import { errorHandle } from '../../Common/errorHandle';
import cognitoAuth from "../../util/Cognito";
import Header from "../CeHeader/Header";
import { InterruptionTable } from "./parts/InterruptionTable";
import { OutputPaperGraph } from "./parts/OutputPaperGraph";
import { AvailabilityResultsGraph } from "./parts/AvailabilityResultsGraph";
import "./TopOperator.css";
import { refreshPageDetail} from "../../Common/ChangeHeaderDate"
import { dateIsSame } from "../../util/util";

class TopOperator extends React.Component {
    
    constructor(props) {
        super(props);
        let today = moment().set({hour:0,minute:0,second:0,millisecond:0});
        this.goToFullscreenOutputPaperGraph = this.goToFullscreenOutputPaperGraph.bind(this);
        this.goToFullscreenAvailabilityResultsGraph = this.goToFullscreenAvailabilityResultsGraph.bind(this);
        this.goToFullscreenInterruptionTable = this.goToFullscreenInterruptionTable.bind(this);
        this.changeToPrevious = this.changeToPrevious.bind(this);
        this.changeToNext = this.changeToNext.bind(this);
        this.resetPeriod = this.resetPeriod.bind(this);
        this.changeDateHeader = this.changeDateHeader.bind(this);

        this.linkToErrorDetail = this.linkToErrorDetail.bind(this);
        this.state = {
            userName: queryString.parse(window.location.search).id,
            isProgress: false,
            printData: {},
            analysisDataList: [],
            machineList: [],
            displayName: 'TopOperator',
            baseDate: moment(today).day(0).format(DATE_FORMAT),
            oneBeforeDate: moment(today).day(0).subtract(7, 'days').format(DATE_FORMAT),
        };
    }

    componentDidMount() {
        let today = moment().set({hour:0,minute:0,second:0,millisecond:0});
        if (this.props.history.location.state) {
            this.setState({
                baseDate: this.props.history.location.state.baseDate ? this.props.history.location.state.baseDate : moment(today).day(0).format(DATE_FORMAT),
                oneBeforeDate: this.props.history.location.state.oneBeforeDate ? this.props.history.location.state.oneBeforeDate : moment(today).day(0).subtract(7, 'days').format(DATE_FORMAT),
            });
        } else {
            this.setState({
                baseDate: moment(today).day(0).format(DATE_FORMAT),
                oneBeforeDate: moment(today).day(0).subtract(7, 'days').format(DATE_FORMAT),
            });
        }
        this.getAnalysis();
    }

    getAnalysis() {
        let header = {
            'Authorization': ''
        };
        
        this.setState({isProgress: true});
        checkRevision().then(() => {
            cognitoAuth.getAuthorizationToken().then((token) => {
                header.Authorization = token;
            }, (error) => {
                throw error;
            }).then(() => {
                const controller = new AbortController();
                const props = this;
                const timer = window.setTimeout(errorHandle(function() {
                    controller.abort();
                    throw props;
                }), TIMEOUT);
                let printListQs = new URLSearchParams({
                    userId: queryString.parse(window.location.search).id,
                    from: this.state.oneBeforeDate,
                    to: moment(this.state.baseDate).add(-1, 'days').format(DATE_FORMAT),
                });
                let getOperatorInfo = fetch(process.env.REACT_APP_CE_OPERATOR_INFO + `?${printListQs}`, {
                    method: "GET",
                    headers: header,
                    signal: controller.signal,
                });
                
                Promise.all([getOperatorInfo]).then(responses => {
                    window.clearTimeout(timer);
                    this.setState({isProgress: false});
                    for (let response of responses) {
                        if (!response.ok) {
                            if (response.status === 408) {
                                // エラーメッセージ表示
                                this.props.openSnackbar(this.props.intl.formatMessage({ id: "http_connection_error" }));
                                return;
                            } else {
                                // エラーメッセージ表示
                                this.props.openSnackbar(this.props.intl.formatMessage({ id: "server_error" }, {status: response.status}));
                                return;
                            }
                        }
                    }

                    Promise.all(responses.map(res => res.json())).then(results => {
                        const{ baseDate, oneBeforeDate } = this.state;
                        if(dateIsSame(baseDate, oneBeforeDate, results[0].startDate, results[0].endDate)) {
                            let printDetail = results[0].printDetail;
                            this.setState({
                                printData: printDetail,
                                analysisDataList: printDetail.analysisResult,
                                machineList: printDetail.machineList
                            });
                        }
                    });
                });
            }).catch(() => {
                this.setState({isProgress: false});
                cognitoAuth.sessionTimeOut(this.props);
            });
        });
    }

    goToFullscreenOutputPaperGraph() {
        this.props.history.push({
            pathname: "/ce/operatorTop/outputpapergraph",
            search: '?id=' + this.state.userName,
            state: this.state,
        });
    }

    changeDateHeader(startDate,endDate){
        refreshPageDetail(startDate,endDate,this,'TopOperator');
        this.getAnalysis();
    }
    

    goToFullscreenAvailabilityResultsGraph() {
        this.props.history.push({
            pathname: "/ce/operatorTop/availabilityresultsgraph",
            search: '?id=' + this.state.userName,
            state: this.state,
        });
    }

    goToFullscreenInterruptionTable() {
        this.props.history.push({
            pathname: "/ce/operatorTop/interruptionTable",
            search: '?id=' + this.state.userName,
            state: this.state,
        });
    }

    changeToPrevious() {
        let today = moment().set({hour:0,minute:0,second:0,millisecond:0});
        let previousBaseDate = moment(this.state.baseDate, DATE_FORMAT).add(-7, 'days').format(DATE_FORMAT);
        this.setState({
            baseDate : previousBaseDate,
            oneBeforeDate: moment(this.state.oneBeforeDate, DATE_FORMAT).add(-7, 'days').format(DATE_FORMAT),
            isInitDate: previousBaseDate === moment(today).day(0).format(DATE_FORMAT),
        });
        this.getAnalysis();
    }

    changeToNext() {
        let today = moment().set({hour:0,minute:0,second:0,millisecond:0});
        let nextBaseDate = moment(this.state.baseDate, DATE_FORMAT).add(7, 'days').format(DATE_FORMAT);
        this.setState({
            baseDate : moment(this.state.baseDate, DATE_FORMAT).add(7, 'days').format(DATE_FORMAT),
            oneBeforeDate: moment(this.state.oneBeforeDate, DATE_FORMAT).add(7, 'days').format(DATE_FORMAT),
            isInitDate: nextBaseDate === moment(today).day(0).format(DATE_FORMAT),
        });
        this.getAnalysis();
    }

    linkToErrorDetail = value => {
    }   

    resetPeriod() {
        let today = moment().set({hour:0,minute:0,second:0,millisecond:0});
        if(this.state.baseDate !== moment(today).day(0).format(DATE_FORMAT)) {
            this.setState({
                baseDate: moment(today).day(0).format(DATE_FORMAT),
                oneBeforeDate: moment(today).day(0).subtract(7, 'days').format(DATE_FORMAT),
                isInitDate: true,
            });
            this.getAnalysis();
        }
    }

    render() {
        return (
            <div id="topOperatorContent" className="contents">
                {this.state.isProgress ? <LinearProgress /> : ''}
                <Header showSubMenu={true} showRange={true}
                    resetPeriod={this.resetPeriod} 
                    beginDate={moment(this.state.oneBeforeDate, DATE_FORMAT)}
                    endDate={moment(this.state.baseDate, DATE_FORMAT).add(-1, 'days')}
                    changeToPrevious={this.changeToPrevious}
                    changeToNext={this.changeToNext} 
                    isInitDate={this.state.isInitDate}
                    changeDateHeader={this.changeDateHeader}
                />
                <div className='content-body'>
                    <div className={this.state.isProgress ? 'left-area' : 'left-area show'}>
                        <div className='content'>
                            <div className="content-title">{this.props.intl.formatMessage({ id: "top_operator_title_production_result" })}</div>
                            <div className="graph-area">
                                <OutputPaperGraph height={this.state.height} width={this.state.width} intl={this.props.intl} analysisDataList={this.state.analysisDataList} onFullScreenButtonClick={this.goToFullscreenOutputPaperGraph} zoomButtonIcon={zoomButtonIcon}/>
                            </div>
                        </div>
                        <div className='content lower'>
                            <div className="graph-area">
                                <AvailabilityResultsGraph intl={this.props.intl} analysisDataList={this.state.analysisDataList} onFullScreenButtonClick={this.goToFullscreenAvailabilityResultsGraph} zoomButtonIcon={zoomButtonIcon}/>
                            </div>
                        </div>
                    </div>
                    <div className={this.state.isProgress ? 'right-area' : 'right-area show'}>
                        <div className='content'>
                            <div className="content-title">{this.props.intl.formatMessage({ id: "top_operator_title_trouble_result" })}</div>
                            <div className="graph-area">
                                <TroubleDataGrid intl={this.props.intl} printData={this.state.printData} linkToErrorDetail={this.linkToErrorDetail}/>
                            </div>
                        </div>
                        <div className='content lower'>
                            <div className="table-area">
                                <InterruptionTable intl={this.props.intl} analysisDataList={this.state.analysisDataList} machineList={this.state.machineList} onFullScreenButtonClick={this.goToFullscreenInterruptionTable} height={320} zoomButtonIcon={zoomButtonIcon}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withSnackbar(withRouter(injectIntl(TopOperator)), SNACKBAR_OPTIONS);
